<template>
	<div>
		<PageHeader/>
		<section id="flower_list">
			<div class="container">
				<div class="row">
					<div class="col-12">
						<div class="list-wrap">
							<div class="slider-wrap">
								<div class="slider brand-slider" style="opacity: 1;">
									<div v-for="(data, id) in all_datas" :class="`flower-id${data.id}`"> 
										<router-link :to="`${id}`"> 
											<div class="brand-wrap">
												<div class="img-wrap">
												<img :src="data.brand_img" alt="">
												</div>
												<div class="name">
												{{ data.nick_name }}
												</div>
												
											</div>
										</router-link>	
									</div>


									

								</div>
							</div>

							<mylist :single_data="single_data"/>


							
							
						</div>
					</div>
				</div>
			</div>
			<ToTopBtn/>
		</section>
	</div>
</template>

<script>

import axios from 'axios';

import mylist from './list';
import PageHeader from '../PageHeader.vue';



export default {
	components: {
		mylist,
		PageHeader
	},
	props: ['id'],
	data(){
		return {
			all_datas: "",
			json_src: './src/assets/json/flower-list.json'

		}
	},
	methods: {
		get_flower_datas() {
            axios.get(this.json_src).then((response) => {
                
                //console.log(response.data)
				this.all_datas = response.data;
				this.brand_slick();

				
				response.data.forEach((e)=>{
                    //console.log(e.id)
                    this.ga_func(".flower-id"+e.id, "印花攻略-"+e.ga_name);
                });

				

				// setTimeout(()=>{
					
				// },10);	
            }, (error) => {
            	console.log(error)
            })
		},
		brand_slick(){
			
			setTimeout(()=>{
				$('.brand-slider').css("opacity", "1");
				$('.slider.brand-slider').slick({
					initialSlide: parseInt(this.id),
					focusOnSelect: true,
					dots: false,
					slidesToShow: 5,
					swipeToSlide: true,
					prevArrow:`
					<svg class='a-left control-c prev slick-prev' version="1.1" id="圖層_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="0 0 42 24" style="enable-background:new 0 0 42 24;" xml:space="preserve">
				<style type="text/css">
					.st0{fill:#6D6D6D;}
				</style>
				<path class="st0" d="M0,12l12,12h6L6,12L18,0h-6L0,12z M12,12l12,12h6L18,12L30,0h-6L12,12z M24,12l12,12h6L30,12L42,0h-6L24,12z"/>
				</svg>`,
					nextArrow:`<svg class='a-right control-c next slick-next' version="1.1" id="圖層_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
				viewBox="0 0 42 24" style="enable-background:new 0 0 42 24;" xml:space="preserve">
				<style type="text/css">
					.st0{fill:#6D6D6D;}
				</style>
				<path class="st0" d="M30,0h-6l12,12L24,24h6l12-12L30,0z M18,0h-6l12,12L12,24h6l12-12L18,0z M6,0H0l12,12L0,24h6l12-12L6,0z"/>
				</svg>`,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 4,
								slidesToScroll: 3,
								infinite: true,
							}
						},
						{
							breakpoint: 600,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 2
							}
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 1
							}
						}
					],

				});


			}, 100);
		},
        ga_func(class_name, name){
            $("body").on('click',class_name , function (e) {
                //alert()
                gtag('event', '點擊', {
                    'event_category': name,
                    'event_action': '點擊',
                    'event_label': '點擊次數'
                });
            });
        }
	},
	computed: {
		single_data(){
			return this.all_datas[this.id];
		}
	},
	mounted(){
		setTimeout(()=>{
			this.get_flower_datas();
		}, 100);
		

		// $(".custom-scroller").mCustomScrollbar({
		// 	theme: "rounded-dots",
		// 	mouseWheelPixels: 80,
		// 	scrollInertia: 0
		// });
		
		
	},
	updated(){
		//this.brand_slick();

		
	}
}
</script>

<style lang="sass">
section#flower_list
	&:before
        content: ''
        background-image: url('../assets/flower-bg.png')
        position: fixed
        display: block
        top: 0
        left: 0
        width: 100%
        height: 100%
        background-size: cover
        background-position: center top
        transform: translateZ(0)
        will-change: transform
        z-index: -1000


</style>



// WEBPACK FOOTER //
// src/FlowerList/main.vue